module.exports = __webpack_public_path__ + "img/2.69ee6023.jpg";